<template>
    <div>
        <Loader :isLoading="isLoading"></Loader>
        <div id="theme-banner-one">
            <div class="illustration wow zoomIn animated" data-wow-delay="1s" data-wow-duration="2s">
                <img :src="$websiteEnvironment.assetsDir + '/website-svgs/zadi/zadi-finish.svg'"
                     style="margin-top: 100px; width: 500px"
                     alt="" class="screen-one wow fadeInLeft animated" data-wow-duration="2s">
            </div>

            <div class="container">
                <div class="main-wrapper">
                    <h4 class="main-title wow fadeInUp animated" data-wow-delay="0.4s">
                        إنتهت المسابقة  <br> 
                    </h4>
                    <h4 class=" wow fadeInUp animated mt-5" data-wow-delay="0.9s">
                        
                        إنتظرونا في المسابقات القادمة

                        <br>
                        شكراً جزيلاُ لمشاركتكم ..
                    </h4>
                    <h4 class="main-title wow fadeInUp animated" data-wow-delay="0.4s">
                    </h4>
                </div>
            </div>
        </div>

        
    </div>
</template>

<script>
  
    export default {
        name: 'zadiFinish',
        metaInfo: {
            title: 'نتائج زادي قريباً'
        }
    }
</script>

<style scoped>

    .solid-inner-banner {
        background: #fafcff;
        text-align: right;
        padding: 265px 0 0;
    }

    #theme-banner-one {
        background: none;
        position: relative;
    }

    #theme-banner-one .illustration {
        position: absolute;
        left: 3%;
        top: 10%;
        width: 45%;
    }

</style>
